import { render } from "./ButtonCommon.vue?vue&type=template&id=ca4bff1c&scoped=true"
import script from "./ButtonCommon.vue?vue&type=script&lang=js"
export * from "./ButtonCommon.vue?vue&type=script&lang=js"

import "./ButtonCommon.vue?vue&type=style&index=0&id=ca4bff1c&lang=scss&scoped=true"

import exportComponent from "/home/sites/fcs_dev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ca4bff1c"],['__file',"resources/js/common/components/molecules/ButtonCommon.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "ca4bff1c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('ca4bff1c', __exports__)) {
    console.log('reload')
    api.reload('ca4bff1c', __exports__)
  }
  
  module.hot.accept("./ButtonCommon.vue?vue&type=template&id=ca4bff1c&scoped=true", () => {
    console.log('re-render')
    api.rerender('ca4bff1c', render)
  })

}


export default __exports__